import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  root: {
    "&:last-child": {
      "& $delete": {
        display: "block",
      },
    },
  },
  main: {
    display: "flex",
    position: "relative",
  },
  fields: {
    flex: 1,
    minWidth: 1,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  attributeType: {
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: getFieldWidth(1),
      marginRight: 12,
    },
  },
  attributeName: {
    width: "100%",
    marginTop: 0,
    [theme.breakpoints.up("md")]: {
      width: getFieldWidth(1),
      marginTop: 0,
      marginRight: 12,
    },
  },
  criteria: {
    width: "100%",
    marginTop: 0,
    [theme.breakpoints.up("md")]: {
      width: getFieldWidth(1),
      marginTop: 0,
      marginRight: 12,
    },
  },
  valueTwo: {
    marginTop: 0,
    width: "100%",
    "&:empty": {
      marginTop: 0,
    },
    [theme.breakpoints.up("md")]: {
      width: getFieldWidth(2),
      marginTop: 0,
    },
  },
  valueThree: {
    [theme.breakpoints.up("md")]: {
      width: getFieldWidth(3),
    },
  },
  valueFour: {
    [theme.breakpoints.up("md")]: {
      width: getFieldWidth(4),
    },
  },
  delete: {
    display: "none",
    position: "absolute",
    bottom: -16,
    right: 0,
    [theme.breakpoints.up("md")]: {
      display: "block",
      position: "initial",
      flex: "0 0 32px",
      textAlign: "right",
      paddingTop: 12,
    },
  },
  deleteButton: {
    width: 20,
    height: 20,
    padding: 0,
    "& svg": {
      width: 20,
      height: 20,
    },
  },
  divider: {
    display: "flex",
    position: "relative",
    height: 22,
    "&::before": {
      content: "''",
      position: "absolute",
      top: 1,
      right: 0,
      left: 32,
      borderTop: `1px dashed ${theme.palette.grey[300]}`,
    },
    [theme.breakpoints.up("md")]: {
      height: 32,
      "&::before": {
        top: 6,
      },
    },
  },
}));

const GAP_COUNT = 4;
const GAP_WIDTH = 12;

function getFieldWidth(columns: number) {
  return `calc((((100% - ${GAP_COUNT * GAP_WIDTH}px) / 5) * ${columns}) + ${
    GAP_WIDTH * (columns - 1)
  }px)`;
}
